import { Badge } from '@mui/material';
import {
  useRecordContext,
  DateFieldProps,
  TextField
} from 'react-admin';

import { YYYYMMDDtoDate } from 'shared/utils/date';

function AcquisitionsField({ ...props }: DateFieldProps) {
  const record = useRecordContext();
  const dateTimes: string[] = record?.[props.source]
  if (!dateTimes?.length) return null
  const dates = dateTimes?.map(dT => YYYYMMDDtoDate(dT?.split("-")?.[1]))
  const dateStrings = dates?.sort()?.map(d => d.toLocaleString(props.locales, props.options))
  const dateString = dateStrings.at(-1)
  if (dateTimes?.length === 1) {
    return <TextField {...props} source="text" record={{ ...record, text: dateString }} />
  }
  return <Badge badgeContent={`+${dateTimes?.length - 1}`} sx={{ '& .MuiBadge-badge': { marginRight: "-0.7em" } }}>
    <TextField {...props} source="text" record={{ ...record, text: dateString }} title={dateStrings.join(" <-> ")} />
  </Badge>
}

export default AcquisitionsField